import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import Home from "@/pages/Home";
import CategoryPage from "@/pages/CategoryPage";
import BlogList from "@/pages/BlogList";
import BlogDetail from "@/pages/BlogDetail";
import GoRedirect from "@/pages/GoRedirect";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<SiteLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/concerttickets" element={<CategoryPage />} />
          <Route path="/festivaltickets" element={<CategoryPage />} />
          <Route path="/vliegtickets" element={<CategoryPage />} />
          <Route path="/attractietickets" element={<CategoryPage />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
        </Route>
        <Route path="/go/:slug" element={<GoRedirect />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
